import LegalPage, { type BusinessIdentity } from '../../components/LegalPage'

interface Props {
  business: BusinessIdentity
}

// Full document text lives in config/locales under frontend.legal.returns.
export default function Returns({ business }: Props) {
  return <LegalPage page="returns" business={business} />
}
